/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { toHeaderCase } from "js-convert-case";
import { USER_GROUP_LIST } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetHolderGroupProps {
  offset?: number;
  size?: number;
}

export interface IHolderGroupsMethods extends IPluginMethodMap {
  getHolderGroupsProps(args: any): Promise<any>;
}

export class HolderGroupsService implements IAgentPlugin {
  readonly methods: IHolderGroupsMethods;

  constructor() {
    this.methods = {
      getHolderGroupsProps: this.getHolderGroupsProps.bind(this),
    };
  }

  async getHolderGroupsProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: USER_GROUP_LIST,
          variables: {
            input: {
              offset: 0,
              size: 100,
              criteria: {
                parent: null,
              },
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data?.getListOfUserGroup) {
          let _templateData = this.formatHolderGroup(
            res?.data?.getListOfUserGroup?.data
          );
          return {
            studentGroup: _templateData,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }

  private formatHolderGroup(data: any) {
    let _userGroups = data.map((item: any) => {
      return {
        label: toHeaderCase(item?.name),
        value: item?._id,
      };
    });

    return _userGroups;
  }
}
